import { cva } from "class-variance-authority";

export const progressVariants = cva(
  "relative h-1.5 w-full overflow-hidden rounded-sm",
  {
    variants: {
      kind: {
        info: "bg-blue-50",
        success: "bg-green-50",
        error: "bg-red-50",
      },
    },
  },
);

export const progressIndicatorVariants = cva(
  "h-full w-full flex-1 transition-all",
  {
    variants: {
      kind: {
        info: "bg-blue-600",
        success: "bg-green-600",
        error: "bg-red-600",
      },
    },
  },
);

export const progressTextVariants = cva("text-xs flex justify-between", {
  variants: {
    kind: {
      info: "text-blue-600",
      success: "text-green-600",
      error: "text-red-600",
    },
  },
});
